type Props = {
  className?: string;
};

export const ChatFinecoCopyIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.665 9.51H7.845L7.8375 9.5025C8.7525 9.5025 9.5025 8.76 9.5025 7.8375V1.665C9.5025 0.75 8.76 0 7.8375 0H1.665C0.75 0 0 0.75 0 1.665V7.845C0 8.76 0.7425 9.51 1.665 9.51ZM1.125 1.665C1.125 1.3725 1.365 1.125 1.665 1.125H7.8375C8.13 1.125 8.3775 1.365 8.3775 1.665V7.8375C8.3775 8.13 8.1375 8.3775 7.8375 8.3775H1.665C1.3725 8.3775 1.125 8.1375 1.125 7.8375V1.665ZM4.155 12H10.335L10.3275 11.9925C11.2425 11.9925 11.9925 11.25 11.9925 10.3275V4.155C11.9925 3.24 11.25 2.49 10.3275 2.49C10.02 2.49 9.765 2.745 9.765 3.0525C9.765 3.36 10.035 3.615 10.3275 3.615C10.62 3.615 10.8675 3.855 10.8675 4.155V10.335C10.8675 10.6275 10.6275 10.875 10.3275 10.875H4.155C3.8625 10.875 3.615 10.6425 3.615 10.335C3.615 10.0275 3.36 9.7725 3.0525 9.7725C2.745 9.7725 2.49 10.0275 2.49 10.335C2.49 11.25 3.2325 12 4.155 12Z"
        fill="currentColor"
      />
    </svg>
  );
};
